import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import vuetify from "./plugins/vuetify";
import dayjs from "dayjs";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { createPinia, PiniaVuePlugin } from "pinia";
import { ApiError } from "@/api";
// import firebase from 'firebase/app'
// import 'firebase/auth'

dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);

Vue.prototype.$snackbar = {};
Vue.prototype.$dialog = {};
Vue.prototype.$dayjs = dayjs;

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.config.productionTip = false;
Vue.config.errorHandler = function (err, vm) {
  if (err instanceof ApiError) {
    vm.$snackbar.add(err.message);
  } else {
    console.log(err);
  }
};

new Vue({
  router,
  vuetify,
  pinia,
  render: (h) => h(App),
}).$mount("#app");
